<template>
  <svg-icon
    type="mdi"
    :path="mdiClose"
    class="close-icon cursor-pointer"
    @click="emit('close')"
  ></svg-icon>
</template>

<script setup>
import { defineEmits } from "vue";
import { mdiClose } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";

const emit = defineEmits(["close"]);
</script>
<style scoped>
.close-icon {
  @apply h-4 w-4 rounded-3xl bg-gray-400 mt-auto mb-auto text-surface-500 bg-transparent p-0.5 flex-shrink-0;
  border: 1px solid var(--p-surface-500);
}
</style>
